import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { analyticsApi, CurrentUsage } from '../../api/analytics';

function meterColor(pct: number): string {
  if (pct >= 95) return '#ef4444';
  if (pct >= 80) return '#f97316';
  if (pct >= 60) return '#eab308';
  return '#10b981';
}

export const UsageWidget: React.FC = () => {
  const [usage, setUsage] = useState<CurrentUsage | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    analyticsApi.getCurrentUsage()
      .then(res => setUsage(res.data.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return null;
  if (!usage) return null;

  const color = meterColor(usage.percentUsed);

  return (
    <div
      className="rounded-xl p-5"
      style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}
    >
      <div className="flex items-center justify-between mb-3">
        <div>
          <div className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-1">Monthly Usage</div>
          <div className="text-white font-semibold text-sm">
            {usage.minutesUsed} / {usage.minutesTotal} min
          </div>
        </div>
        <div className="flex flex-col items-end gap-1">
          <span className="text-xl font-bold" style={{ color }}>{usage.percentUsed}%</span>
          <span className="text-xs text-gray-500">{usage.daysLeftInPeriod}d left</span>
        </div>
      </div>

      <div className="w-full bg-gray-800 rounded-full h-2 overflow-hidden mb-2">
        <div
          className="h-2 rounded-full transition-all duration-500"
          style={{ width: `${Math.min(100, usage.percentUsed)}%`, background: color }}
        />
      </div>

      <div className="flex items-center justify-between">
        <span className="text-xs text-gray-500 capitalize">{usage.plan} plan</span>
        {usage.percentUsed >= 80 ? (
          <Link
            to="/billing"
            className="text-xs text-indigo-400 hover:text-indigo-300 no-underline font-medium"
          >
            Upgrade →
          </Link>
        ) : (
          <Link
            to="/analytics"
            className="text-xs text-gray-500 hover:text-gray-400 no-underline"
          >
            Details →
          </Link>
        )}
      </div>
    </div>
  );
};
